import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "page__header row wrap justify-between items-center content-center" }
const _hoisted_2 = { class: "col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-5 text-right" }
const _hoisted_3 = { class: "col-xs-12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-7", { row: _ctx.rowStart }])
    }, [
      _renderSlot(_ctx.$slots, "start")
    ], 2),
    _createElementVNode("div", _hoisted_2, [
      _renderSlot(_ctx.$slots, "end")
    ]),
    _createElementVNode("div", _hoisted_3, [
      _renderSlot(_ctx.$slots, "bottom")
    ])
  ]))
}